/** @jsx jsx */
import { jsx, Interpolation } from '@emotion/core';
import React, { Children, cloneElement } from 'react';
import AsyncIndicator from '../AsyncIndicator';
import { get } from 'lodash';

type AsyncOverlayProps = {
  children: React.ReactElement;
  /** Fixes scroll position and takes up entire screen */
  isFixed?: boolean;
  /** Is indicator visible */
  isVisible?: boolean;
  /** Used to render a custom Indicator */
  renderAsyncIndicator?: () => React.ReactNode;
};

const overlayCss = ({ isFixed }: AsyncOverlayProps): Interpolation => ({
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: isFixed ? 'fixed' : 'absolute',
  top: 0,
  width: '100%',
  // Used to render on top of dropdown menus
  zIndex: 901,
});

/**
 * Renders a loading indicator on top of children content
 */
const AsyncOverlay = (props: AsyncOverlayProps) => {
  const {
    children,
    isVisible = false,
    renderAsyncIndicator = () => <AsyncIndicator />,
  } = props;
  //const { props: childrenProps } = children;
  const childrenProps = get(children, 'props', {});

  //const { style: childrenStyle = {} } = childrenProps;
  const childrenStyle = get(childrenProps, 'style', {});

  // Clone the child and set it's position to relative if needed.
  // This allows the overlay to seamlessly cover the whole
  // area of the child.
  return cloneElement(
    children,
    {
      ...childrenProps,
      style: {
        ...childrenStyle,
        position: get(childrenStyle, 'position', 'relative'),
      },
    },
    [
      ...Children.toArray(get(children, ['props', 'children'])),
      isVisible && (
        <div css={overlayCss(props)} key="indicator">
          {renderAsyncIndicator()}
        </div>
      ),
    ]
  );
};

/** @component */
export default AsyncOverlay;
